module.exports = __webpack_public_path__ + "img/special1.1734731f.png";